var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.499,
    height: 19.501,
    viewBox: "0 0 21.499 19.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1939",
    "data-name": "Group 1939",
    transform: "translate(-1117.25 -326.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_172",
    "data-name": "Union 172",
    d: "M4511.183,4764.751h-14.364a1.753,1.753,0,0,1-1.75-1.751v-11.264a1.755,1.755,0,0,1,.018-.25H4495a1.751,1.751,0,0,1-1.75-1.75V4747a1.752,1.752,0,0,1,1.75-1.751h18a1.752,1.752,0,0,1,1.75,1.751v2.737a1.751,1.751,0,0,1-1.75,1.75h-.085a1.755,1.755,0,0,1,.018.25V4763A1.752,1.752,0,0,1,4511.183,4764.751Zm-14.364-13.264a.25.25,0,0,0-.25.25V4763a.251.251,0,0,0,.25.251h14.364a.251.251,0,0,0,.25-.251v-11.264a.25.25,0,0,0-.25-.25Zm14.364-1.5H4513a.25.25,0,0,0,.25-.25V4747a.251.251,0,0,0-.25-.251h-18a.251.251,0,0,0-.25.251v2.737a.25.25,0,0,0,.25.25Z",
    transform: "translate(-3376 -4419)",
    fill: "#767983"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2620",
    "data-name": "Rectangle 2620",
    width: 6,
    height: 1.5,
    rx: 0.75,
    transform: "translate(1125 335.798)",
    fill: "#767983"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchive);
export default __webpack_public_path__ + "static/media/icon-archive.7d65f03d.svg";
export { ForwardRef as ReactComponent };